export default "__VITE_ASSET__BIir5CQX__"